var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 1080,
    preserveAspectRatio: "none",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(\"#SvgjsMask1855\")",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    x: 0,
    y: 0,
    fill: "url(#SvgjsLinearGradient1856)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1462.8072835766825 463.1600081891122L1227.5131726563798 243.7447000765817 1008.0978645438493 479.0388109968844 1243.391975464152 698.4541191094149z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1378.2905888467635 24.15656628494765L1250.623094833472 147.4436321613327 1373.9101607098569 275.11112617462425 1501.5776547231485 151.8240602982392z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.617,825.36C532.544,826.561,567.049,812.453,583.576,782.8C599.755,753.771,591.68,718.362,573.9,690.285C557.456,664.317,529.352,648.282,498.617,648.637C468.492,648.985,441.495,665.982,426.287,691.989C410.923,718.262,408.967,750.378,423.476,777.132C438.683,805.173,466.738,824.231,498.617,825.36",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.354,270.225C292.261,272.656,332.844,259.634,351.22,226.39C369.178,193.901,354.55,155.472,335.343,123.705C316.98,93.334,289.793,68.105,254.354,66.18C215.515,64.07,174.489,79.484,156.543,113.993C139.527,146.715,157.284,183.947,176.855,215.208C194.873,243.988,220.469,268.052,254.354,270.225",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.55706333138204 623.3226818743123L-79.43254104786695 589.7955234483306-112.95969947384856 908.7851278275796 206.02990490540043 942.3122862535613z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.5761755485294 828.420399731166L721.410555011466 904.933605033923 797.923760314223 1055.0992255709864 948.0893808512864 978.5860202682293z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.2355496317514 748.3036926243599L942.8527120675385 541.0765954658891 735.6256149090676 537.459433030102 732.0084524732806 744.6865301885728z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.367,1480.167C647.738,1483.888,746.473,1417.844,796.644,1322.843C843.847,1233.463,824.093,1127.777,772.313,1040.968C721.98,956.585,638.618,893.978,540.367,893.2C440.859,892.412,349.952,950.064,301.969,1037.242C255.616,1121.459,267.554,1221.437,313.115,1306.086C361.587,1396.143,438.155,1476.625,540.367,1480.167",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "SvgjsMask1855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "89.06%",
    y1: "-19.44%",
    x2: "10.94%",
    y2: "119.44%",
    gradientUnits: "userSpaceOnUse",
    id: "SvgjsLinearGradient1856"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(33, 150, 243, 1)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(13, 71, 161, 1)",
    offset: 1
  })), /*#__PURE__*/React.createElement("style", null, "\r\n            @keyframes float1 {\r\n                0%{transform: translate(0, 0)}\r\n                50%{transform: translate(-10px, 0)}\r\n                100%{transform: translate(0, 0)}\r\n            }\r\n\r\n            .triangle-float1 {\r\n                animation: float1 5s infinite;\r\n            }\r\n\r\n            @keyframes float2 {\r\n                0%{transform: translate(0, 0)}\r\n                50%{transform: translate(-5px, -5px)}\r\n                100%{transform: translate(0, 0)}\r\n            }\r\n\r\n            .triangle-float2 {\r\n                animation: float2 4s infinite;\r\n            }\r\n\r\n            @keyframes float3 {\r\n                0%{transform: translate(0, 0)}\r\n                50%{transform: translate(0, -10px)}\r\n                100%{transform: translate(0, 0)}\r\n            }\r\n\r\n            .triangle-float3 {\r\n                animation: float3 6s infinite;\r\n            }\r\n        "))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBlue);
export default __webpack_public_path__ + "static/media/bgBlue.bacdcf3994287d59410dd91a6856beb3.svg";
export { ForwardRef as ReactComponent };